import { Link } from 'react-router-dom';
import { SectionHeading, StarRating } from '../ui';

/**
 * C13 stories: eyebrow + H2 + intro, three photo cards with a white name bar
 * overlapping the photo bottom, then a first-person line under each, linking
 * to the story page. Real families only (Family Focus, Clara, the Johnsons).
 * The Google review quotes live in Testimonials.tsx (just above).
 */
const STORIES = [
  {
    to: '/family-focus/',
    name: 'The J. Family',
    img: { src: '/images/family-focus/j-family-w640.webp', width: 640, height: 853, alt: 'The J. family, parents and five children, at our office' },
    quote: 'The whole team is fantastic, the adjustments are gentle, and the office is kid/family-friendly.',
    stars: true,
    focal: '50% 30%',
  },
  {
    to: '/eczema/',
    name: 'Clara',
    img: { src: '/images/site-2026/clara-baby-bib.webp', width: 387, height: 425, alt: 'Clara as a smiling baby in an I love my Van Every chiropractor bib' },
    quote: 'Words cannot express our gratitude for the type of care that our family receives from Van Every Family Chiropractic Center.',
    stars: true,
    focal: '50% 35%',
  },
  {
    to: '/celebrating-the-johnson-family-marchs-family-of-the-month/',
    name: 'The Johnson Family',
    img: { src: '/images/family-focus/Johnson-Family-1.webp', width: 1024, height: 690, alt: 'The Johnson family, Renee, Reese, Noah and Jeremy' },
    quote: 'Renee, Reese, Noah, and Jeremy: four very different reasons to get adjusted, one Family of the Month.',
    stars: false,
    focal: '50% 40%',
  },
];

export default function Stories() {
  return (
    <section className="ve-section ve-home-stories" aria-labelledby="home-stories-title">
      <div className="ve-container">
        <SectionHeading
          title="Family Stories"
          id="home-stories-title"
          align="center"
          intro={
            <>
              Families come to us for far more than back pain, and many stay for years. Read a few of
              their stories, then browse <Link to="/patient-reviews/">more patient reviews</Link>.
            </>
          }
        />
        <ul className="ve-home-story-grid">
          {STORIES.map((s) => (
            <li key={s.to}>
              <Link to={s.to} className="ve-home-story">
                <span className="ve-home-story-photo ve-photo-frame ve-photo-frame--4x3">
                  <img
                    src={s.img.src}
                    alt={s.img.alt}
                    width={s.img.width}
                    height={s.img.height}
                    loading="lazy"
                    decoding="async"
                    style={{ objectPosition: s.focal }}
                  />
                  <span className="ve-home-story-name">{s.name}</span>
                </span>
                {s.stars ? <StarRating /> : <span className="ve-home-story-tag">Family of the Month</span>}
                <span className="ve-home-story-quote">{s.stars ? `“${s.quote}”` : s.quote}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
